import * as React from "react";
import type { SVGProps } from "react";
const SvgXCircleContained = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#000"
      d="M16.101 9.313a1 1 0 1 0-1.414-1.414l.707.707zM7.9 14.687a1 1 0 1 0 1.414 1.414l-.707-.707zm6.788 1.414a1 1 0 0 0 1.414-1.414l-.707.707zM9.313 7.9a1 1 0 0 0-1.414 1.414l.707-.707zM21.6 12h-1a8.6 8.6 0 0 1-8.6 8.6v2c5.854 0 10.6-4.746 10.6-10.6zM12 21.6v-1A8.6 8.6 0 0 1 3.4 12h-2c0 5.854 4.746 10.6 10.6 10.6zM2.4 12h1A8.6 8.6 0 0 1 12 3.4v-2C6.146 1.4 1.4 6.146 1.4 12zM12 2.4v1a8.6 8.6 0 0 1 8.6 8.6h2c0-5.854-4.746-10.6-10.6-10.6zm3.394 6.206-.707-.707-3.394 3.394L12 12l.707.707 3.394-3.394zM12 12l-.707-.707-3.394 3.394.707.707.707.707 3.394-3.394zm3.394 3.394.707-.707-3.394-3.394L12 12l-.707.707 3.394 3.394zM12 12l.707-.707-3.394-3.394-.707.707-.707.707 3.394 3.394z"
    />
  </svg>
);
export default SvgXCircleContained;
